import { useMutation } from '@tanstack/react-query';
import { resolveResendErrorCode } from '../register.utils';
import { resendRegistrationCode } from '@/services/register.service';
import type { ResendUserRegistrationError } from '@/services/register.types';

interface UseRegistrationResendMutationArgs {
  registrationToken: string;
  onSuccess: () => void;
  onError: (errorCode?: ResendUserRegistrationError) => void;
}

const useRegistrationResendMutation = ({
  registrationToken,
  onSuccess,
  onError,
}: UseRegistrationResendMutationArgs) =>
  useMutation({
    mutationFn: () => resendRegistrationCode({ registrationToken }),
    onSuccess,
    onError: (error) => onError(resolveResendErrorCode(error)),
  });

export default useRegistrationResendMutation;
